import { createStitches } from '@stitches/react';

export const {
  styled,
  css,
  globalCss,
  keyframes,
  getCssText,
  theme,
  createTheme,
  config,
} = createStitches({
  theme: {
    colors: {
      primary: '#fca903',
      text: '#888888',
    },
    fonts: {
      serif: "'Cinzel', serif",
      sans: "'Montserrat', sans-serif",
    },
  },
});

export const globalStyles = globalCss({
  'html': {
    lineHeight: 1.15,
    '-ms-text-size-adjust': '100%',
    '-webkit-text-size-adjust': '100%',
  },
  'body': {
    margin: 0,
    backgroundColor: 'black',
    '@media(min-width:900px)': {
      backgroundColor: '#111111',
    },
    color: '#888888',
    fontFamily: '$sans',
    lineHeight: '24px',
    letterSpacing: '1px',
  },
  'article, aside, footer, header, nav, section': {
    display: 'block',
  },
  'h1': {
    fontSize: '2em',
    margin: '0.67em 0',
  },
  'figcaption, figure, main': {
    display: 'block',
  },
  'figure': {
    margin: '1em 40px',
  },
  'hr': {
    boxSizing: 'content-box',
    height: 0,
    overflow: 'visible',
  },
  'pre': {
    fontFamily: 'monospace, monospace',
    fontSize: '1em',
  },
  'a': {
    backgroundColor: 'transparent',
    '-webkit-text-decoration-skip': 'objects',
    color: '$primary',
    textDecoration: 'none',
  },
  'abbr[title]': {
    borderBottom: 'none',
    textDecoration: 'underline dotted',
  },
  'b, strong': {
    fontWeight: 'bolder',
  },
  'code, kbd, samp': {
    fontFamily: 'monospace, monospace',
    fontSize: '1em',
  },
  'dfn': {
    fontStyle: 'italic',
  },
  'mark': {
    backgroundColor: '#ff0',
    color: '#000',
  },
  'small': {
    fontSize: '80%',
  },
  'sub, sup': {
    fontSize: '75%',
    lineHeight: 0,
    position: 'relative',
    verticalAlign: 'baseline',
  },
  'sub': {
    bottom: '-0.25em',
  },
  'sup': {
    top: '-0.5em',
  },
  'audio, video': {
    display: 'inline-block',
  },
  'audio:not([controls])': {
    display: 'none',
    height: 0,
  },
  'img': {
    borderStyle: 'none',
  },
  'svg:not(:root)': {
    overflow: 'hidden',
  },
  'button, input, optgroup, select, textarea': {
    fontFamily: 'sans-serif',
    fontSize: '100%',
    lineHeight: 1.15,
    margin: 0,
  },
  'button, input': {
    overflow: 'visible',
  },
  'button, select': {
    textTransform: 'none',
  },
  '[type="reset"], [type="submit"], button, html [type="button"]': {
    '-webkit-appearance': 'button',
  },
  '[type="button"]::-moz-focus-inner, [type="reset"]::-moz-focus-inner, [type="submit"]::-moz-focus-inner, button::-moz-focus-inner': {
    borderStyle: 'none',
    padding: 0,
  },
  '[type="button"]:-moz-focusring, [type="reset"]:-moz-focusring, [type="submit"]:-moz-focusring, button:-moz-focusring': {
    outline: '1px dotted ButtonText',
  },
  'fieldset': {
    padding: '0.35em 0.75em 0.625em',
  },
  'legend': {
    boxSizing: 'border-box',
    color: 'inherit',
    display: 'table',
    maxWidth: '100%',
    padding: 0,
    whiteSpace: 'normal',
  },
  'progress': {
    display: 'inline-block',
    verticalAlign: 'baseline',
  },
  'textarea': {
    overflow: 'auto',
    backgroundColor: 'silver',
  },
  '[type="checkbox"], [type="radio"]': {
    boxSizing: 'border-box',
    padding: 0,
  },
  '[type="number"]::-webkit-inner-spin-button, [type="number"]::-webkit-outer-spin-button': {
    height: 'auto',
  },
  '[type="search"]': {
    '-webkit-appearance': 'textfield',
    outlineOffset: '-2px',
  },
  '[type="search"]::-webkit-search-cancel-button, [type="search"]::-webkit-search-decoration': {
    '-webkit-appearance': 'none',
  },
  '::-webkit-file-upload-button': {
    '-webkit-appearance': 'button',
    font: 'inherit',
  },
  'details, menu': {
    display: 'block',
  },
  'summary': {
    display: 'list-item',
  },
  'canvas': {
    display: 'inline-block',
  },
  'template': {
    display: 'none',
  },
  '[hidden]': {
    display: 'none',
  },
  'ul, li': {
    listStyle: 'none',
    margin: 0,
    padding: 0,
  },
  'h1, h2, h3, h4': {
    color: '$primary',
    fontFamily: '$serif',
    textTransform: 'uppercase',
    letterSpacing: '2px',
    '&::first-letter': {
      fontSize: '1.3em',
    },
  },
  'button': {
    backgroundColor: '$primary',
    color: 'black',
    borderRadius: '5px',
    padding: '5px 15px',
    border: 'none',
    fontFamily: '$sans',
    fontWeight: 'bold',
    cursor: 'pointer',
  },
  'input': {
    backgroundColor: 'silver',
  },
});
